import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Button,
  Box,
  Stack,
  Chip,
  Link as MuiLink,
  useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export default function ModalContactSupport({ open, onChange }) {
  const theme = useTheme();
  const handleClose = () => onChange?.(false);

  const email = 'customerservice@advisorycloud.com';
  const phoneDisplay = '(415) 289-7115';
  const phoneTel = '+14152897115';

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      aria-labelledby="contact-support-title"
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: 'hidden',
          boxShadow: '0px 12px 32px rgba(0,0,0,0.18)',
        },
      }}
    >
      <Box
        sx={{
          px: 3,
          py: '10px',
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          background: theme.palette.primary.main,
          color: 'primary.contrastText',
        }}
      >
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: '999px',
            bgcolor: 'rgba(255,255,255,0.18)',
            display: 'grid',
            placeItems: 'center',
            flexShrink: 0,
          }}
        >
          <HelpOutlineIcon fontSize="small" />
        </Box>
        <DialogTitle
          id="contact-support-title"
          sx={{ m: 0, p: 0, fontWeight: 800, fontSize: '1.1rem', flex: 1 }}
        >
          Get In Touch
        </DialogTitle>
        <IconButton
          aria-label="Close"
          onClick={handleClose}
          edge="end"
          sx={{
            color: 'primary.contrastText',
            '&:hover': { bgcolor: 'rgba(255,255,255,0.12)' },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ p: 3 }}>
        <Stack spacing={2}>
          <Stack spacing={1.25}>
            <Typography variant="overline" sx={{ color: 'text.secondary', letterSpacing: 0.6 }}>
              Email us at
            </Typography>

            <Chip
              icon={<MailOutlineIcon />}
              label={
                <MuiLink href={`mailto:${email}`} underline="hover" color="inherit">
                  {email}
                </MuiLink>
              }
              variant="outlined"
              sx={{
                justifyContent: 'flex-start',
                height: 40,
                borderRadius: 2,
              }}
              // clickable
              // component="a"
              // href={`mailto:${email}`}
            />
          </Stack>
          <Stack spacing={1.25}>
            <Typography variant="overline" sx={{ color: 'text.secondary', letterSpacing: 0.6 }}>
              Call us at
            </Typography>

            <Chip
              icon={<LocalPhoneIcon />}
              label={
                <MuiLink href={`tel:${phoneTel}`} underline="hover" color="inherit">
                  {phoneDisplay}
                </MuiLink>
              }
              variant="outlined"
              sx={{
                justifyContent: 'flex-start',
                height: 40,
                borderRadius: 2,
              }}
              // clickable
              // component="a"
              href={`tel:${phoneTel}`}
            />
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} fullWidth>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
